let accessToken: string | undefined = undefined;
let refreshToken: string | undefined = undefined;
let registerToken: string | undefined = undefined;

export const logout = () => {
  accessToken = undefined;
  refreshToken = undefined;
  if (typeof window !== "undefined") {
    try {
      localStorage.clear();
    } catch {}
    try {
      sessionStorage.clear();
    } catch {}
  }
};

export const setAccessToken = (s: string) => {
  accessToken = s;
  if (typeof window !== "undefined") {
    try {
      sessionStorage.setItem("accessToken", s);
    } catch {}
  }
};

export const getAccessToken = () => {
  if (accessToken === "" || accessToken === undefined) {
    if (typeof window !== "undefined") {
      try {
        const token = sessionStorage.getItem("accessToken");
        if (token) accessToken = token;
      } catch {}
    }
  }
  return accessToken;
};

export const setRefreshToken = (s: string) => {
  refreshToken = s;
  if (typeof window !== "undefined") {
    try {
      localStorage.setItem("refreshToken", s);
    } catch {}
  }
};

export const getRefreshToken = () => {
  if (refreshToken === "" || refreshToken === undefined) {
    if (typeof window !== "undefined") {
      try {
        const token = localStorage.getItem("refreshToken");
        if (token) refreshToken = token;
      } catch {}
    }
  }
  return refreshToken;
};

export const setRegisterToken = (s: string) => {
  registerToken = s;
  if (typeof window !== "undefined") {
    try {
      localStorage.setItem("registerToken", s);
    } catch {}
  }
};

export const getRegisterToken = () => {
  if (registerToken === "" || registerToken === undefined) {
    if (typeof window !== "undefined") {
      try {
        const token = localStorage.getItem("registerToken");
        if (token) registerToken = token;
      } catch {}
    }
  }
  return registerToken;
};
